import Request from './request'

async function fetch (id,data) {
  return Request('get', 'api/take-material-templates/view-by-template/' + id,data)
}

async function batchSave(data) {
    return Request('post', "api/take-material-templates/batch-save", data);
}

export default {
  fetch,
  batchSave,
}